<sirius-container>
    <div class="feature-list">
        @if (resolvedTitle() || resolvedTextHtml()) {
            <div class="feature-list-header">
                @if (resolvedTitle()) {
                    <sirius-heading [h]="2" [text]="resolvedTitle()" textStyleCategory="title" textStyleSize="l" />
                }
                @if (resolvedTextHtml()) {
                    <sirius-text-html [html]="resolvedTextHtml()" textStyleSize="l" />
                }
            </div>
        }
        <ul class="feature-list-items" role="list">
            @for (row of rows(); track $index) {
                <li class="feature-list-item">
                    <div class="feature-list-heading-group">
                        @if (row.iconName) {
                            <sirius-icon class="feature-list-icon" [name]="row.iconName" aria-hidden="true" />
                        }
                        <div class="feature-list-heading">
                            <sirius-heading [h]="3" [text]="row.title" textStyleCategory="title" textStyleSize="s" />
                            @if (row.subtitle) {
                                <p class="feature-list-subtitle">{{ row.subtitle }}</p>
                            }
                        </div>
                    </div>
                    <sirius-text-html
                        class="feature-list-body"
                        [html]="row.textHtml"
                        textStyleSize="m"
                    />
                </li>
            }
        </ul>
    </div>
</sirius-container>
